import { render, staticRenderFns } from "./JdsNavigator.vue?vue&type=template&id=77aa70bb&scoped=true&"
import script from "./JdsNavigator.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigator.vue?vue&type=style&index=0&id=77aa70bb&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa70bb",
  null
  
)

export default component.exports